"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getWindowObject = require("./get-window-object");

Object.keys(_getWindowObject).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getWindowObject[key];
    }
  });
});

var _hasFormData = require("./has-form-data");

Object.keys(_hasFormData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _hasFormData[key];
    }
  });
});

var _hasRetinaScreen = require("./has-retina-screen");

Object.keys(_hasRetinaScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _hasRetinaScreen[key];
    }
  });
});

var _hasWindowListeners = require("./has-window-listeners");

Object.keys(_hasWindowListeners).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _hasWindowListeners[key];
    }
  });
});

var _hasWindow = require("./has-window");

Object.keys(_hasWindow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _hasWindow[key];
    }
  });
});

var _isThenable = require("./is-thenable");

Object.keys(_isThenable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _isThenable[key];
    }
  });
});
//# sourceMappingURL=index.js.map